import { HTMLAttributes, useContext } from 'react';

import Link from 'next/link';

import { LocalesContext } from '@/context/locales/LocalesProvider';
import { classMerge } from '@/utils/class-names';
import { interpolateNodes } from '@/utils/Interpolate';

export interface PoliciesProps extends HTMLAttributes<HTMLDivElement> {}

/**
 * Policies Library Component
 */
export const Policies = ({ className, children, ...props }: PoliciesProps) => {
	const { locales } = useContext(LocalesContext);

	return (
		<div data-cy="Policies" {...props} className={classMerge('', className)}>
			{interpolateNodes(
				locales.recaptcha,
				<Link href="https://policies.google.com/privacy" key="1">
					<a
						className="text-neutral-black hover:underline underline-offset-1"
						target="_blank"
						rel="noopener noreferrer"
					>
						{locales['privacy-policy']}
					</a>
				</Link>,
				<Link href="https://policies.google.com/terms" key="2">
					<a
						className="text-neutral-black hover:underline underline-offset-1"
						target="_blank"
						rel="noopener noreferrer"
					>
						{locales['terms-service']}
					</a>
				</Link>
			)}
		</div>
	);
};

Policies.propTypes = {};
